import React from 'react'
import {
	Link
}from 'react-router-dom'
import {
	useSelector,
	useDispatch
}from 'react-redux'

import {
	Layout, Menu, Row, Col
}from 'antd'
import {
	UserOutlined
}from '@ant-design/icons'

import Login from '../../Login'
import {
	userActions
}from '../../../store/actions/user'

import 'antd/lib/row/style/css'
import 'antd/lib/col/style/css'
import 'antd/lib/layout/style/css'
import 'antd/lib/menu/style/css'

import './index.css'

import logo from './logo.svg'

function Header(){
	const { user } = useSelector((state) => state.userReducer)

	const dispatch = useDispatch()

	const logout = () => {
		dispatch(userActions.logout())
		const iframe = document.getElementById("iframe")
		iframe?.contentWindow?.postMessage({
			action: 'clearToken'
		}, "*")
	}

	const refreshUserData = () => {
		dispatch(userActions.refreshUserData({}))
	}

	return (
		<Layout.Header className="layout-header">
			<div
				id="loginToken"
				style={ { display: "none" } }
				onClick={ () => refreshUserData() }
			/>
			<Row
				align="middle"
				className="layout-header-row"
			>
				<Col
					md={ 2 }
					sm={ 3 }
					xl={ 1 }
					xs={ 3 }
				>
					<Link to="/">
						<img
							alt="Логотип"
							className="layout-header-logo"
							src={ logo }
						/>
					</Link>
				</Col>
				<Col
					className="layout-header-high-col"
					md={ 3 }
					sm={ 2 }
					xl={ 3 }
					xs={ 4 }
				>
					<Link
						className="nav-link"
						to="/"
					>
						<h3 className="scp-title">
							ГосСтройПортал
						</h3>
					</Link>
				</Col>
				<Col
					className="layout-header-high-col"
					md={ 13 }
					offset={ 6 }
					sm={ 13 }
					xl={ 14 }
					xs={ 11 }
				>
					<Menu
						className="layout-header-menu none-color-item-focus"
						mode="horizontal"
						theme="light"
					>
						<Menu.Item key="1">
							<a
								className="nav-link"
								href="https://gosstroyportal.by/"
							>
								<h3>
									Сервисы
								</h3>
							</a>
						</Menu.Item>
						<Menu.Item key="2">
							<a
								className="nav-link"
								href="https://gosstroyportal.by/"
							>
								<h3>
									Подразделы и сервисы
								</h3>
							</a>
						</Menu.Item>
						<Menu.Item key="3">
							<a
								className="nav-link"
								href="https://gosstroyportal.by/"
							>
								<h3>
									Помощь
								</h3>
							</a>
						</Menu.Item>
						<Menu.Item key="4">
							<a
								className="nav-link"
								href="https://gosstroyportal.by/contacts"
							>
								<h3>
									Контакты
								</h3>
							</a>
						</Menu.Item>
						{ user.isLoggedIn
							? (
								<Menu.SubMenu
									key="5"
									className="layout-header-submenu"
									title={ (
										<div
											className="nav-link"
											to="#"
										>
											<h3>
												{ user.userName ?? 'Личный кабинет' }
											</h3>
										</div>
									) }
								>
									<Menu.Item
										key="6"
										className="none-color-item-focus layout-header-submenu-menu-item"
									>
										<Link
											className="nav-link"
											to="/account"
										>
											<h3>
												Личный кабинет
											</h3>
										</Link>
									</Menu.Item>
									<Menu.Item
										key="7"
										className="nav-link none-color-item-focus layout-header-submenu-menu-item"
										onClick={ () => logout() }
									>
										<h3>
											Выйти
										</h3>
									</Menu.Item>
								</Menu.SubMenu>
							)
							: (
								<Menu.SubMenu
									key="5"
									className="layout-header-submenu"
									title={ (
										<div
											className="nav-link"
											to="#"
										>
											<h3>
												<UserOutlined />
											</h3>
										</div>
									) }
								>
									<Menu.Item
										key="6"
										className="none-color-item-focus layout-header-submenu-menu-item"
									>
										<a
											className="nav-link"
											href="https://gosstroyportal.by/registration"
										>
											<h3>
												Регистрация
											</h3>
										</a>
									</Menu.Item>
									<Menu.Item
										key="7"
										className="none-color-item-focus layout-header-submenu-menu-item"
									>
										<Login />
									</Menu.Item>
								</Menu.SubMenu>
							) }
					</Menu>
				</Col>
			</Row>
		</Layout.Header>
	)
}

export default Header
